export enum LoginPageTestIds {
  LOGIN_EMAIL = 'login-email',
  LOGIN_PASSWORD = 'login-password',
  ENTER_BUTTON = 'enter-button',
  FEDERATED_LOGIN_BUTTON = 'federated-login-button',
  PUBLIC_LOGIN_BUTTON = 'public-login-button',
  ENTER_WITH_EMAIL_BUTTON = 'enter-with-email-button',
}
